import { render, staticRenderFns } from "./nav-configuration.vue?vue&type=template&id=1031f4fa&scoped=true&"
import script from "./nav-configuration.vue?vue&type=script&lang=js&"
export * from "./nav-configuration.vue?vue&type=script&lang=js&"
import style0 from "./nav-configuration.vue?vue&type=style&index=0&id=1031f4fa&scoped=true&lang=less&rel=stylesheet%2Fless&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1031f4fa",
  null
  
)

export default component.exports